import React from 'react';
import './TemplateIconField.css';
import Textfield from '../input/Textfield';
import { colorVar, normalizeColorKey } from '../../util/participantGroups';
import { sanitizeIconName } from './templateModel';

/**
 * Small text field for a Material Symbol name with a live preview tile. Empty = the caller's
 * fallback icon (shown as placeholder and in the preview). colorKey tints the preview.
 */
function TemplateIconField({ label = 'Icon', value, onChange, fallbackIcon, colorKey, ariaLabel }) {
  const key = normalizeColorKey(colorKey);
  return (
    <div className="ptIconField">
      <Textfield
        label={label}
        value={value}
        placeholder={fallbackIcon}
        maxLength={50}
        autoComplete="off"
        spellCheck={false}
        aria-label={ariaLabel ?? label}
        onChange={e => onChange?.(sanitizeIconName(e.target.value))}
      />
      <span
        className={`material-symbols-rounded ptIconPreview${key === 'neutral' ? ' isNeutral' : ''}`}
        style={{ '--pt-icon-color': colorVar(key) }}
        title="Vorschau"
        aria-hidden="true"
      >
        {value || fallbackIcon}
      </span>
    </div>
  );
}

export default TemplateIconField;
